import React from 'react';
import { Instagram, Facebook, Youtube, Mail, MapPin } from 'lucide-react';
import { siteConfig, socialLinks } from '../mock';
import { useTranslation } from '../i18n/LanguageContext';

const Footer = () => {
  const { t } = useTranslation();
  return (
    <footer className="bg-card border-t mt-auto">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid md:grid-cols-2 gap-12 mb-8">
          {/* Brand Section */}
          <div className="space-y-4">
            <div className="flex flex-col">
              <span className="text-3xl font-black tracking-tight text-gradient">NPCMOP</span>
              <span className="text-xs font-semibold text-muted-foreground mt-1">
                {siteConfig.fullName}
              </span>
            </div>
            <p className="text-sm text-muted-foreground leading-relaxed">
              {t('common.tagline')}
            </p>
            <div className="flex space-x-3">
              <a
                href={socialLinks.instagram}
                target="_blank"
                rel="noopener noreferrer"
                className="p-2 rounded-full bg-secondary hover:bg-primary hover:text-primary-foreground transition-colors"
                aria-label="Instagram"
              >
                <Instagram className="h-5 w-5" />
              </a>
              <a
                href={socialLinks.facebook}
                target="_blank"
                rel="noopener noreferrer"
                className="p-2 rounded-full bg-secondary hover:bg-primary hover:text-primary-foreground transition-colors"
                aria-label="Facebook"
              >
                <Facebook className="h-5 w-5" />
              </a>
              <a
                href={socialLinks.youtube}
                target="_blank"
                rel="noopener noreferrer"
                className="p-2 rounded-full bg-secondary hover:bg-primary hover:text-primary-foreground transition-colors"
                aria-label="YouTube"
              >
                <Youtube className="h-5 w-5" />
              </a>
            </div>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="font-bold text-lg mb-4">{t('footer.contactUs')}</h3>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3 text-sm text-muted-foreground">
                <Mail className="h-5 w-5 mt-0.5 flex-shrink-0 text-primary" />
                <a href={`mailto:${siteConfig.email}`} className="hover:text-primary transition-colors">
                  {siteConfig.email}
                </a>
              </li>
              <li className="flex items-start space-x-3 text-sm text-muted-foreground">
                <MapPin className="h-5 w-5 mt-0.5 flex-shrink-0 text-primary" />
                <span>{t(siteConfig.address)}</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-sm text-muted-foreground text-center md:text-left">
              © {new Date().getFullYear()} {siteConfig.name}. {t('footer.rightsReserved')}
            </p>
            <p className="text-sm text-muted-foreground italic text-center md:text-right">
              {`"${t('footer.tagline')}"`}
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
